<div class="info-page">
  <h3>{{infoProjeto.menu.produto.tipo_cadastro_formatted}} - {{ actionLabel }} </h3>
</div>

<form [formGroup]="form" (ngSubmit)="salvar()">
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">{{infoProjeto.menu.produto.tipo_cadastro_formatted}}</label>
      <textarea rows="4" id="description" class="form-control" formControlName="description"></textarea>
      <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Meta</label>
      <textarea rows="4" id="ds_goal" class="form-control" formControlName="ds_goal"></textarea>
      <app-field-message [field]="fieldMessageRequired('ds_goal')" [erros]="fieldErros('ds_goal')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Custo estimado</label>
      <input type="text" id="value" class="form-control text-end" formControlName="value" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" autocomplete="off"/>
      <app-field-message [field]="fieldMessageRequired('value')" [erros]="fieldErros('value')"></app-field-message>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 col-md-5 col-lg-4 form-group mb-3">
      <label class="col-sm-12 pb-1">Início</label>
      <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="date_start" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }">
      <app-field-message [field]="fieldMessageRequired('date_start')" [erros]="fieldErros('date_start')"></app-field-message>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 col-md-5 col-lg-4 form-group mb-3">
      <label class="col-sm-12 pb-1">Término</label>
      <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="date_conclusion" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }">
      <app-field-message [field]="fieldMessageRequired('date_conclusion')" [erros]="fieldErros('date_conclusion')"></app-field-message>
    </div>
  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end m-b">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-danger m-r-xs btn-excluir" *ngIf="entity?.id" (click)="confirmExcluir()" type="button">Excluir</button>
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-primary" type="submit">Salvar</button>
    </div>
  </div>
</form>

<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>